import { ErrorMessage } from '@hookform/error-message';
import _ from 'lodash';
import type { ChangeEvent, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Field, FieldErrorMessage, Label } from '@/primitives/fieldset.tsx';
import { Input } from '@/primitives/input.tsx';
import { Select } from '@/primitives/select.tsx';
import { useFetchRepresentativeStatusesQuery } from '@/slices/representative-api-slice.ts';
import type { FormControlProps } from '../../types/form-props.type.ts';
import type { RepresentativeStatusModel } from '../../types/representative-status.type.ts';

const RepresentativeStatusSelector: FC<FormControlProps> = ({
  name,
  label = 'Status',
  displayProperty = 'description',
  hideLabel,
  disabled,
  required,
}) => {
  const { data, isLoading } = useFetchRepresentativeStatusesQuery();
  const { register, setValue, getFieldState, watch, formState } = useFormContext();

  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    setValue(
      name,
      data?.find(x => x.id === parseInt(event.target.value)),
    );
  };

  return (
    <Field>
      {!hideLabel && <Label required={required}>{label}</Label>}
      <Select
        onChange={onChange}
        value={watch(name)?.id}
        invalid={getFieldState(name).invalid}
        disabled={disabled}
      >
        <option>--{label}--</option>
        {!isLoading &&
          data?.length &&
          data.map((option: RepresentativeStatusModel) => (
            <option key={option.id} value={option.id}>
              {_.get(option, displayProperty)}
            </option>
          ))}
      </Select>
      <Input
        type='hidden'
        {...register(name, { required: required && 'This field is required', disabled: disabled })}
      />
      <ErrorMessage name={name} as={<FieldErrorMessage />} errors={formState.errors} />
    </Field>
  );
};

export default RepresentativeStatusSelector;
